var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => {
  __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
  return value;
};
import NavigationService from "@ane/core/lib/services/NavigationService";
import { ROUTES } from "./Routes.constants.js";
class Util {
  constructor() {
    __publicField(this, "_modulePath", ROUTES.dataSourceManagement.root.match.path);
    __publicField(this, "_modulePathname", ROUTES.dataSourceManagement.root.location.pathname);
    __publicField(this, "routes", {
      root: {
        path: () => `${this.path}`,
        getURL: () => `${this.url}`
      },
      list: {
        path: () => `${this.path}`,
        getURL: () => `${this.url}`
      },
      view: {
        path: () => `${this.path}${ROUTES.dataSourceManagement.view.match.path}`,
        getURL: (payload) => {
          const { id, pivot, view } = payload;
          let append = !!pivot ? `/${pivot}` : "";
          append += !!view ? `/${view}` : "";
          return `${this.url}/${id}${append}`;
        }
      },
      create: {
        path: () => `${this.path}${ROUTES.dataSourceManagement.create.match.path}`,
        getURL: () => {
          return `${this.url}${ROUTES.dataSourceManagement.create.location.pathname}`;
        }
      },
      overrideview: {
        path: () => `${this.path}${ROUTES.dataSourceManagement.overrideview.match.path}`,
        getURL: (payload) => {
          const { id, dataSourceType, dataSourceOverrideName, pivot, view } = payload;
          let append = !!dataSourceOverrideName ? `/${dataSourceOverrideName}` : "";
          append += !!pivot ? `/${pivot}` : "";
          append += !!view ? `/${view}` : "";
          return `${this.url}/${id}/${dataSourceType}/override${append}`;
        }
      },
      overridecreate: {
        path: () => `${this.path}${ROUTES.dataSourceManagement.overridecreate.match.path}`,
        getURL: (payload) => {
          const { id, dataSourceType, fromVersion } = payload;
          let append = !!fromVersion ? `/${fromVersion}` : "";
          return `${this.url}/${id}/${dataSourceType}/override/create${append}`;
        }
      }
    });
  }
  /**
   * React Router regex path
   */
  get path() {
    return `${NavigationService.root.path}${this._modulePath}`;
  }
  /**
   * Pathname used to construct complete URL
   */
  get url() {
    return `${NavigationService.root.url}${this._modulePathname}`;
  }
}
const DataSourceRouteUtils = new Util();
export {
  DataSourceRouteUtils
};
//# sourceMappingURL=DataSourceRoute.utils.js.map
